export default "__VITE_ASSET__O9QQR_8r__"